export const getCountry = () => {
  const userDomain = window.location.hostname.split('.').pop()
  if (userDomain === 'de') return 'germany'
  if (userDomain === 'at') return 'austria'
  if (userDomain === 'ch') return 'switzerland'
  if (userDomain === 'uk') return 'uk'
  return 'fallback'
}
